
<template>
    <div class="el-Header">
        <div class="headerLeft">
            <div class="headerTitle">
                <!-- 如果需要可以放logo -->
                <img src="@/assets/logoTitle.png" alt="" />
                <div v-if="false">
                  <img src="@/assets/breadcrumb-icon.png" alt="">
                   <Breadcrumb :toggleSideBarHide="toggleSideBarHide" @menuShowChange="(e)=>menu_show=e"></Breadcrumb>
                </div>
            </div>
            <el-menu
                :default-active="activeMenu"
                @select="handleSelect"
                active-text-color="#FFFFFF"
                class="menuList"
                mode="horizontal"
                text-color="#FFFFFF"
            >
                <!-- 首页按钮 -->
                <!-- <div class="nav-item">
                    <router-link to="/index">
                        <el-menu-item
                            index="/"
                            class="menuItem"
                        >首页/el-menu-item>
                    </router-link>
                </div> -->
                <!-- 一级路由菜单 -->
                <template v-for="item in routes">
                    <div :key="item.path" class="nav-item" v-if="!item.hidden">
                        <a
                            v-if="item.isExternal"
                            :href="item.externalUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <el-menu-item
                                :index="item.path"
                                class="menuItem"
                                style="font-size: 18px; font-weight: 600;"
                            >
                                <span>{{ item.meta.title }}</span>
                            </el-menu-item>
                        </a>
                        <router-link v-else :to="resolvePath(item)">
                            <el-menu-item
                                :index="item.path"
                                class="menuItem"
                                style="font-size: 18px; font-weight: 600;"
                            >
                                <!-- 图标：如果是图标类名则使用i标签，如果是图片路径则使用img标签 -->
                                <i v-if="item.meta && item.meta.icon && item.meta.icon.indexOf('.') === -1" 
                                   :class="item.meta.icon" 
                                   class="menu-icon"></i>
                                <img v-else-if="item.meta && item.meta.icon" 
                                     :src="getIconUrl(item.meta.icon)" 
                                     class="menu-icon-img" 
                                     alt="" />
                                <span>{{ item.meta.title }}</span>
                            </el-menu-item>
                        </router-link>
                    </div>
                </template>
                
                <!-- 更多菜单 -->
                <el-submenu class="menuItem" index="more" v-if="moreArr && moreArr.length">
                    <template slot="title">更多
                        <img alt="" src="@/assets/menuMore.png">
                    </template>
                    <template v-for="item in moreArr">
                        <router-link v-if="!item.isExternal" :key="item.path" :to="resolvePath(item)">
                            <el-menu-item
                                :index="item.path"
                                class="menuItem moreMenuItem"
                                style="color: #333;background: #fff;"
                            >
                                <i v-if="item.meta && item.meta.icon && item.meta.icon.indexOf('.') === -1" 
                                   :class="item.meta.icon" 
                                   class="menu-icon"></i>
                                <img v-else-if="item.meta && item.meta.icon" 
                                     :src="getIconUrl(item.meta.icon)" 
                                     class="menu-icon-img" 
                                     alt="" />
                                <span>{{ item.meta.title }}</span>
                            </el-menu-item>
                        </router-link>
                        <a
                            v-else
                            :key="item.path + '-external'"
                            :href="item.externalUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <el-menu-item
                                :index="item.path"
                                class="menuItem moreMenuItem"
                                style="color: #333;background: #fff;"
                            >
                                <span>{{ item.meta.title }}</span>
                            </el-menu-item>
                        </a>
                    </template>
                </el-submenu>
            </el-menu>
        </div>
        <user-opt></user-opt>
    </div>
</template>

<script>
import UserOpt from '@/layout/components/UserOpt'
import Breadcrumb from '@/components/Breadcrumb'
import { getListByDictType } from '@/api/sys/dictData'

export default {
  components: {
    UserOpt,
    Breadcrumb
  },
  data() {
    return {
      routes: [], // 一级路由
      baseRoutes: [],
      newArr: [],
      existing: 0,
      moreArr: [],
      isb: false,
      toggleSideBarHide: false,//侧边栏显示隐藏
      menu_show: true,
    }
  },
  computed: {
    activeMenu() {
      const route = this.$route
      const {meta, path} = route
      
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      
      if (path === '/index') {
        return '/'
      }
      
      const pathSegments = path.split('/').filter(Boolean)
      if (pathSegments.length > 0) {
        return `/${pathSegments[0]}`
      }
      
      return path
    }
  },
  created() {
    this.initRoutes()
    this.loadServerTypeNav()
  },
  mounted() {
    this.initCurrentRoutes()
    this.adjustMenuWidth()
    //this.debugMoreMenu()
  },
  watch: {
    // 监听路由变化，更新 currentRoutes
    '$route'() {
      this.initCurrentRoutes()
    }
  },
  methods: {
    // 初始化路由
    initRoutes() {
      // 从Vuex获取所有路由
      const allRoutes = this.$store.state.route.routes || []
      
      // 过滤出一级路由
      this.baseRoutes = allRoutes.filter(route => {
        return !route.hidden && 
               route.meta && 
               route.meta.title &&
               route.path !== '/' &&
               route.path !== '/index' &&
               route.path !== '/login' &&
               route.path !== '/404' &&
               route.path !== '/403' &&
               route.path !== '*'
      }).map(route => ({
        ...route,
        path: route.path.startsWith('/') ? route.path : '/' + route.path
      }))
      this.routes = [...this.baseRoutes]
    },

    // 加载 server_type 字典并追加到一级导航
    async loadServerTypeNav() {
      try {
        const res = await getListByDictType('server_type')
        if (res && res.code === 200 && Array.isArray(res.data)) {
          const externalRoutes = res.data
            .filter(item => (item.code || item.dictLabel) && (item.value || item.dictValue))
            .map((item, index) => ({
              path: `/external-server-${index}`,
              hidden: false,
              isExternal: true,
              externalUrl: item.value || item.dictValue,
              meta: {
                title: item.code || item.dictLabel
              }
            }))
          this.routes = [...this.baseRoutes, ...externalRoutes]
          this.$nextTick(() => {
            this.adjustMenuWidth()
          })
        }
      } catch (error) {
        console.error('加载 server_type 导航失败:', error)
      }
    },

    // 获取菜单宽度// 在methods中添加一个调试方法
    // debugMoreMenu() {
    //   // 假设你有5个一级路由，我们让最后2个进入"更多"菜单
    //   if (this.routes.length > 3) {
    //     // 将最后2个路由放入moreArr
    //     const visibleCount = this.routes.length - 2;
    //     this.moreArr = this.routes.slice(visibleCount);
    //     this.routes = this.routes.slice(0, visibleCount);
        
    //     // 同时更新existing变量，确保其他逻辑正常
    //     this.existing = visibleCount;
    //   }
    // },
    // 调整菜单宽度
    adjustMenuWidth() {
      let newArr = JSON.parse(JSON.stringify(this.routes))
      let menuitem = document.getElementsByClassName('menuItem')
      let widthArr = []
      
      for (let i = 0; i < menuitem.length; i++) {
        widthArr.push(menuitem[i].clientWidth)
      }
      
      this.isbeyond(widthArr)
      
      // 处理更多菜单
      let arr = []
      if (this.existing != 0) {
        arr = newArr.splice(this.existing, newArr.length - 1)
      }
      this.moreArr = arr
    },
    
    // 宽度计算
    isbeyond(widthArr) {
      let menu = document.getElementsByClassName('menuList')
      if (this.sum(widthArr) > menu[0].clientWidth) {
        this.isb = true
        let newArr = this.routes.slice(0, this.routes.length - 1)
        let newWidthArr = widthArr.slice(0, this.routes.length - 1)
        this.routes = newArr
        this.isbeyond(newWidthArr)
      } else {
        if (this.isb) {
          let newArr = this.routes.slice(0, this.routes.length - 1)
          let newWidthArr = widthArr.slice(0, this.routes.length - 1)
          this.routes = newArr
          this.existing = newWidthArr.length
        }
      }
    },
    
    sum(arr) {
      return arr.reduce((prev, curr) => prev + curr, 0)
    },
    
    // 初始化当前路由
    initCurrentRoutes() {
      const {path} = this.$route
      const topRoute = this.findTopRouteByPath(path)
      
      if (topRoute) {
        this.$store.commit('SET_CURRENT_ROUTES', topRoute)
        this.setSidebarHide(topRoute)
      }
    },
    
    // 根据路径找到一级路由
    findTopRouteByPath(path) {
      const pathSegments = path.split('/').filter(Boolean)
      if (pathSegments.length === 0) return null
      
      const topPath = `/${pathSegments[0]}`
      return this.routes.find(route => route.path === topPath)
    },
    
    // 解析路径 - 递归到最后一级的第一个子项
    resolvePath(item) {
      // 如果是首页，就返回重定向路由
      if (item.path === '/') {
        return '/index'
      }
      
      /**
       * 递归获取默认路径
       * @param {Object} currentItem - 当前路由项
       * @param {String} parentPath - 父级路径（用于拼接）
       * @returns {String} 完整的路径
       */
      const getDefaultPath = (currentItem, parentPath = '') => {
        // 构建当前路径
        let currentPath = ''
        if (parentPath) {
          // 如果父路径以 / 结尾，不需要再加 /
          currentPath = parentPath.endsWith('/') 
            ? (parentPath + currentItem.path)
            : (parentPath + '/' + currentItem.path)
        } else {
          // 如果没有父路径，确保以 / 开头
          currentPath = currentItem.path.startsWith('/') 
            ? currentItem.path 
            : ('/' + currentItem.path)
        }
        
        // 如果还有子项，继续递归到最后一级
        if (currentItem.children && currentItem.children.length > 0) {
          // 过滤掉隐藏的子项
          const visibleChildren = currentItem.children.filter(child => !child.hidden)
          if (visibleChildren.length > 0) {
            // 递归调用，传入当前完整路径作为新的父路径
            return getDefaultPath(visibleChildren[0], currentPath)
          }
        }
        
        // 没有子项或所有子项都隐藏，返回当前路径
        return currentPath
      }

      if (item.children && item.children.length > 0) {
        // 过滤掉隐藏的子项
        const visibleChildren = item.children.filter(child => !child.hidden)
        if (visibleChildren.length > 0) {
          return getDefaultPath(visibleChildren[0], item.path)
        }
      }
      
      return item.path
    },
    
    // 菜单选择
    handleSelect(key) {
      let allArr = [...this.moreArr, ...this.routes]
      const route = allArr.find(item => item.path === key)
      
      if (route && route.isExternal) {
        return
      }

      if (route) {
        localStorage.setItem('selectedTopRoute', JSON.stringify(route))
        this.$store.commit('SET_CURRENT_ROUTES', route)
        this.setSidebarHide(route)
      }
    },
    
    // 设置侧边栏显示/隐藏
    setSidebarHide(route) {
      if (route && route.children && route.children.length > 1) {
        this.$emit('toggleSideBarHide', true)
      } else {
        this.$emit('toggleSideBarHide', false)
      }
    },
    
    // 获取图标URL（如果是图片路径，需要拼接前缀）
    getIconUrl(icon) {
      if (!icon) return ''
      // 如果已经是完整URL（以http://或https://开头），直接返回
      if (icon.startsWith('http://') || icon.startsWith('https://')) {
        return icon
      }
      // 否则拼接imageUrlprefix前缀
      const prefix = this.$imageUrlprefix || process.env.VUE_APP_IMAGEURLPREFIX || ''
      return prefix + icon
    }
  }
}
</script>


<style lang='scss' scoped>
    a {
        text-decoration: none;
    }

    .el-Header {
        // padding-left: 11px;
        height: 73px;
        background-image: url("~@/assets/headerBg.png");
        background-size: 100% 73px;
        background-repeat: no-repeat;
        color: #333;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .headerLeft {
            display: flex;
            align-items: center;

            .headerTitle {
                min-width: 305px;
                display: flex;
                align-items: center;

                > img {
                    width: 240px;
                    height: 53px;
                }

                div {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                    img {
                        width: 24px;
                        height: 24px;
                    }
                }
            }

            .menuList {
                // margin-left: calc(20vw + 58px);
                // float: right;
                flex: 1;
                // display: flex;
                line-height: 73px;
                background-color: transparent;
                display: flex;
                align-items: center;
            }
        }

        .headerLeft {
            display: flex;
            align-items: center;

            .nav-item {
                // min-width: 112px;
                // height: 48px;
                // border: 1px solid #376486;
                border-radius: 5px;
                font-size: 24px;
                font-family: Lantinghei SC;
                font-weight: 800;
                color: #ffffff;
                text-align: center;
                line-height: 48px;

                a {
                    text-decoration: none;
                }

                display: inline-block;

                .is-active {
                    border-bottom: 2px solid #FCB122 !important;
                    background-color: #005FDF66 !important;
                }

                .el-menu-item {
                    line-height: 73px;
                    height: 73px;
                    padding: 0px 24px;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    // color: rgb(191, 203, 217);

                    .menu-icon {
                        font-size: 18px;
                        color: #FFFFFF;
                    }

                    .menu-icon-img {
                        width: 18px;
                        height: 18px;
                        object-fit: contain;
                    }

                    &:hover {
                        // border-bottom-width: 0;
                        background-color: transparent;
                        // background-color: $mainColor !important;
                    }

                    &:focus {
                        // border-bottom-width: 0;
                        background-color: transparent;
                        // border-bottom: 2px solid #194FC9;
                        // background-color: $mainColor !important
                        // background-color: $mainColor !important;
                        // color: $subMenuActiveText !important;
                    }
                }
            }
        }
    }

    
    /deep/ .el-menu--horizontal > .el-submenu {
        float: right !important;

        .el-submenu_title {

        }
    }

    .el-menu--horizontal > .el-submenu /deep/ .el-submenu__title {
        line-height: 73px;
        height: 73px;
        font-family: Lantinghei SC;
        font-weight: 200;
        color: #FFFFFF !important;
        display: flex;
        align-items: center;

        img {
            width: 24px;
            height: 24px;
        }

        .el-submenu__icon-arrow {
            display: none;
        }
    }

    /deep/ .el-submenu__title:focus, /deep/ .el-submenu__title:hover {
        background-color: #0484E5 !important;
        border-bottom: 3px solid #B0E8FF !important;
        // line-height: 63px;
        // height: 65px;
    }
    .el-menu--popup-bottom-start{
    padding: 0!important;
    }

    // 确保菜单项垂直居中
    /deep/ .el-menu--horizontal {
        display: flex;
        align-items: center;
        height: 73px;
    }

    /deep/ .el-menu--horizontal .el-menu-item {
        height: 73px;
        line-height: 73px;
        display: flex;
        align-items: center;
    }

    // 确保选中状态的文字颜色为白色
    /deep/ .el-menu--horizontal .el-menu-item.is-active {
        color: #FFFFFF !important;
        background-color: #005FDF66 !important;
    }

    /deep/ .el-menu--horizontal .el-menu-item.is-active .menu-icon {
        color: #FFFFFF !important;
    }

    /deep/ .el-menu--horizontal .el-menu-item.is-active span {
        color: #FFFFFF !important;
    }
</style>
